import { StarMark } from "@/components/Logo";

const ITEMS = [
  "Extensão Capilar",
  "Cabelo Humano Selecionado",
  "Mega Hair",
  "Perucas Imperceptíveis",
  "Topos Capilares",
  "Cortes & Escova",
  "Manicure & Unhas em Gel",
  "Compramos Cabelo",
  "Brasília/DF",
];

export const Marquee = () => (
  <div className="overflow-hidden border-y border-[#D4AF37]/15 bg-[#0A0A0B] py-5" aria-hidden="true">
    <div className="animate-marquee flex w-max items-center gap-10">
      {[...Array(4)].flatMap((_, r) =>
        ITEMS.map((item, i) => (
          <span key={`${r}-${i}`} className="flex items-center gap-10">
            <span className="whitespace-nowrap font-display text-lg italic tracking-wide text-[#F9F8F6]/70">
              {item}
            </span>
            <StarMark className="h-3 w-3 opacity-50" />
          </span>
        )),
      )}
    </div>
  </div>
);
